module.exports = __webpack_public_path__ + "img/tool_marker_active.329f4617.png";